import UltMeta, { Meta } from "./UltMeta";

/**
 * 发起方
 */
class Initiator extends UltMeta {
    /**
     * 内部客户
     */
    ADMIN = new Meta(1, "管理后台");
    /**
     * 客户
     */
    CUSTOM = new Meta(2, "用户端");
}
export const INITIATOR = new Initiator();

/**
 * 合同类型
 */
class Type extends UltMeta {
    BUY = new Meta(1, "采购");
    SELL = new Meta(2, "销售");
}

export const TYPE = new Type();

/**
 * 合同类型
 */
class ContractType extends UltMeta {
    PURCHASE = new Meta(1, "采购合同");
    SALES = new Meta(2, "销售合同");
    PAYMENT_COMMISSION = new Meta(3, "支付委托书");
    LOAN_APPLICATION = new Meta(4, "提款申请书");
    LOAN_AGREEMENT = new Meta(5, "借款合同");
    LOAN_GUARANTEE = new Meta(6, "借款凭证");
    GUARANTEE_AGREEMENT = new Meta(7, "担保合同");
    // WAREHOUSING = new Meta(11, "仓储合同");
    INTEGRATED_SERVICE = new Meta(8, "综合服务协议");
    SUPPLEMENTAL_AGREEMENT = new Meta(9, "补充协议");
    OTHER = new Meta(10, "其他");
}

export const CONTRACT_TYPE = new ContractType();

/**
 * 融资产品
 */
class FinancingProduct extends UltMeta {
    COMMERCE_STEEL_TRADE = new Meta(1, "商贸通(钢贸)");
    BILL_PASS = new Meta(2, "票据通");
    GENERAL_WORKING_CAPITAL_LOAN = new Meta(3, "一般流动资金贷款");
    COMMERCIAL_BILL_GUARANTEE_ENHANCEMENT = new Meta(4, "商业汇票保证增信");
    COMMERCIAL_BILL_DISCOUNT_ENHANCEMENT = new Meta(5, "商业汇票保贴增信");
    SMART_WAREHOUSE_LOAN = new Meta(6, "智慧仓储贷");
    GENERAL_WORKING_CAPITAL_LOAN_SUPPLY_CHAIN = new Meta(7, "一般流动资金贷款-供应链");
}

export const FINANCING_PRODUCT = new FinancingProduct();

/**
 * 借款利率方式
 */
class BorrowingInterestRateType extends UltMeta {
    FIXED = new Meta(1, "固定");
    FLOATING = new Meta(2, "浮动");
}

export const BORROWING_INTEREST_RATE_TYPE = new BorrowingInterestRateType();

/**
 * 结息周期方式
 */
class InterestSettlementCycleType extends UltMeta {
    MONTHLY = new Meta(1, "按月");
    QUARTERLY = new Meta(2, "按季");
    YEARLY = new Meta(3, "按年");
}

export const INTEREST_SETTLEMENT_CYCLE_TYPE = new InterestSettlementCycleType();

/**
 * 合同状态 查询  给到后端的
 */
class StateQuery extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_INITIATE = new Meta(7, "待发起");
    TO_BE_SIGNED = new Meta(8, "待签署");
    SIGNING = new Meta(2, "签署中");
    PENDING_CONFIRMATION = new Meta(3, "待确认");
    CONFIRMING = new Meta(4, "确认中");
    REJECTED = new Meta(5, "已驳回");
    COMPLETED = new Meta(6, "签署完成");
}
export const STATE_QUERY = new StateQuery();

/**
 * 合同状态 列表详情 后端返回的
 * 只有管理后台会发起
 * 管理后台：确认中--3
 * 用户pc：待确认--3
 *
 * 管理后台：待签署state=2，signStatus=0或1；签署中state=2，signStatus=2
 * 用户pc：待签署state=2，signStatus=0或2；签署中state=2，signStatus=1
 */
class State extends UltMeta {
    DRAFT = new Meta(1, "草稿", STATE_QUERY.DRAFT.code);
    TO_BE_INITIATE = new Meta(6, "待发起", STATE_QUERY.TO_BE_INITIATE.code);
    SIGNING = new Meta(2, "签署中", `${STATE_QUERY.SIGNING.code},${STATE_QUERY.TO_BE_SIGNED.code}`);
    PENDING_CONFIRMATION = new Meta(3, "待确认", `${STATE_QUERY.PENDING_CONFIRMATION.code},${STATE_QUERY.CONFIRMING.code}`);
    REJECTED = new Meta(4, "已驳回", STATE_QUERY.REJECTED.code);
    COMPLETED = new Meta(5, "签署完成", STATE_QUERY.COMPLETED.code);
}
export const STATE = new State();

/**
 * 签署方式
 */
class SignMode extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}
export const SIGN_MODE = new SignMode();

class SignYesMode extends UltMeta {
    NO = new Meta(0, "否");
    YES = new Meta(1, "是");
}
export const SIGN_YES_MODE = new SignYesMode();
/**
 * 签署渠道
 * 当签署方式为线上时为契约锁，签署方式为线下时为线下
 */
class SignChannel extends UltMeta {
    ONLINE = new Meta(1, "契约锁");
    OFFLINE = new Meta(2, "线下");
}
export const SIGN_CHANNEL = new SignChannel();

/**
 * 支付方式
 */
class PurchaserPayType extends UltMeta {
    CASH = new Meta(1, "现金");
    BANK_TRANSFER = new Meta(2, "银行转账");
    LETTER_OF_CREDIT = new Meta(3, "信用证");
    BANK_ACCEPTANCE = new Meta(4, "银行承兑汇票");
    COMMERCIAL_ACCEPTANCE = new Meta(5, "商业承兑汇票");
}

export const PURCHASER_PAY_TYPE = new PurchaserPayType();

/**
 * 保存方式枚举
 */
class HasSubmit extends UltMeta {
    SAVE_AS_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_SUBMIT = new Meta(2, "保存并提交");
}

export const HAS_SUBMIT = new HasSubmit();
// 采购类型的这个字段是空，销售类型的 在发起签署之后，双方都没签署的时候 也是空的
class SignStatus extends UltMeta {
    UNSIGNED = new Meta(0, "双方未签署");
    BUYER_SIGNED = new Meta(1, "买方签署完成");
    SUPPLY_SIGNED = new Meta(2, "销售方签署完成");
    COMPLETED = new Meta(3, "双方签署已完成");
}
export const SIGN_STATUS = new SignStatus();

/**
 * 结算方式
 */
class SettleWay extends UltMeta {
    GOODS_FIRST = new Meta(1, "先货后款");
    PAYMENT_FIRST = new Meta(2, "先款后货");
}
export const SETTLE_WAY = new SettleWay();

/**
 * 账期起始方式
 */
class SettleStartWith extends UltMeta {
    SIGNATURE_CONFIRMATION = new Meta(1, "签收确认日期");
    PURCHASE_CONFIRMATION = new Meta(2, "采购确认日期");
}
export const SETTLE_START_WITH = new SettleStartWith();
